import { useState } from "react";
import { useTranslation } from "Shared/util/custom-hooks";
import PropTypes from "prop-types";
import { SettingsCard } from "Shared/components/cards";
import AccountPlanEditView from "Pages/accountplan/accountplan-edit-view/accountplan-edit-view";

const AccountplanSettingsCard = ({ className }) => {
    const [showSidebar, setShowSidebar] = useState(false);
    const t = useTranslation(
        (x) => x.company_settings.accountplan_settings_card,
    );

    const handleShowSidebar = () => setShowSidebar(true);
    const handleHideSidebar = () => setShowSidebar(false);

    return (
        <>
            <SettingsCard
                header={{
                    text: t.chart_of_accounts,
                }}
                content={t.chart_of_accounts_description}
                action={{
                    text: t.edit,
                    svg: "/edit.svg",
                    onClick: handleShowSidebar,
                }}
                className={className || ""}
            />

            <AccountPlanEditView show={showSidebar} hide={handleHideSidebar} />
        </>
    );
};

AccountplanSettingsCard.propTypes = {
    className: PropTypes.string,
};

export default AccountplanSettingsCard;
